import React, { ReactElement, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Form, Row } from 'antd';
import { GUTTOR_SPACE, authFeatureConstants } from '../../../shared/constants/commonConstants';
import { reArrangeOptions } from '../../crm/inPatient/service/crmUtils';
import { RootState } from '../../../store';
import { ApplicationDetailModel } from '../../../store/models/applicationDetailModel';
import { setCenterId } from '../../../store/actions/mailBoxAction';
import { MailboxType } from '../../../store/models/mailBoxModel';
import FormSelect from '../../../shared/components/crmFormElement/FormSelect/FormSelect';
import { getHospDetail, setUserAuthData } from '../../../store/actions/authAction';
import { canActivate, centeredNotification, emptyFunction, isGroupUser } from '../../../utils/utility';
import { decryptText } from '../../../utils/encryptDecrypt';
import { ReactComponent as DownArrow} from '../../../assets/images/svg/DownArrow.svg';

const GroupLoginConfiguration = ({ match, location }: any): ReactElement => {
    const [configForm] = Form?.useForm();
    const appDetail = useSelector((state: RootState): ApplicationDetailModel => state.applicationDetail);
    const { enabledPayer, centerId } =
        useSelector((state: RootState): MailboxType => state?.mailBox || {});
    const logOutBtnClicked = useSelector(
        ({ hospital: { isLogOutBtnClicked } }: any): any => isLogOutBtnClicked,
    );
    const groupProviders = appDetail?.getGroupProviders();
    const [centerOptions, setCenterOptions] = useState([]);
    const [onPanelLeave, setPanelLeave] = useState(false);
    const dispatch = useDispatch();
    const mounted = useRef(false);

    const popStateHandler = (ev: PopStateEvent): void => {
        ev.preventDefault();
      };

    useEffect((): any => {
        if (centerId && enabledPayer) {
            dispatch(getHospDetail([centerId], getHospSuccess, getHospFailure));
        }
    }, [centerId]);

    useEffect((): any => {
        mounted.current = true;
        return (): boolean => {
          window.onbeforeunload = emptyFunction;
          window.removeEventListener('popstate', popStateHandler);
          dispatch(setCenterId(0));
          if (canActivate(authFeatureConstants.NEW_ADMISSION_BEHALF_OF_HOSPITALS) && isGroupUser() && logOutBtnClicked === false) {
            const providerDetailString: any = decryptText(localStorage.getItem('providerDetail') || '{}');
            const providerDetail = JSON.parse(providerDetailString);
            dispatch(setUserAuthData(providerDetail));
          }
          return mounted.current = false;
      };
      }, []);

    useEffect((): void => {
        const reArrangeCenterOptions =
            reArrangeOptions(
                groupProviders,
                'providerId',
                'providerName',
                {
                    isRestRequired: true,
                    additionalLabelKey: 'providerRohiniCode',
                    additionalLabelKeyDivider: '|',
                },
            );
        setCenterOptions(reArrangeCenterOptions);
    }, [groupProviders]);

    const onChangeCenter = (event: any): any => {
        localStorage?.setItem('selectedCenter', event);
        if (event) {
            dispatch(getHospDetail([event], getHospSuccess, getHospFailure));
        }
        dispatch(setCenterId(event));
    };

    const getHospSuccess = (result: any): void => {
        dispatch(setUserAuthData(result));
    };

    const getHospFailure = (errMsg: string): any => {
        centeredNotification(errMsg);
    };

    const handleMouseLeave = (): any => {
        setPanelLeave(false);
    };

    const handleMouseEnter = (): any => {
        setPanelLeave(true);
    };
    return (
        <>
            <div className="group-tbl-content w-100">
                <Row gutter={GUTTOR_SPACE} className="group-tbl-content w-100"
                    onMouseLeave={handleMouseLeave} onMouseEnter={handleMouseEnter}>
                    <Col md={16} className="mailbox-center-selection">
                        <FormSelect detail={{
                            showSearch: true,
                            hideLabel: true,
                            placeholder: 'Select the Center',
                            allowClear: false,
                            defaultValue: enabledPayer !== 0 ? localStorage.getItem('datacenter') : undefined,
                            onChange: (event: any): any => onChangeCenter(event),
                            size: 12,
                            key: 'grouplogincenter',
                            form: configForm,
                            isGroupLogin: groupProviders?.length ? true : false,
                            className: 'centerSelection',
                            options: centerOptions || [],
                            suffixIcon: <DownArrow/>,
                            onPanelLeave,
                        }} />
                    </Col>
                </Row>
                {centerId === 0 && <p className="group-tbl-content w-100 configure-center mailbox-center-selection">
                    Please select a center to configure</p>}
            </div>
        </>
    );
};
export default GroupLoginConfiguration;
